import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Help"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12ZM13.125 17.625C13.125 18.2463 12.6213 18.75 12 18.75C11.3787 18.75 10.875 18.2463 10.875 17.625C10.875 17.0037 11.3787 16.5 12 16.5C12.6213 16.5 13.125 17.0037 13.125 17.625ZM12.75 6.00001H11.625C10.7293 5.99801 9.86969 6.35295 9.23632 6.98632C8.60295 7.61969 8.24801 8.47929 8.25001 9.37501V9.75001H9.75001V9.37501C9.75001 8.33947 10.5895 7.50001 11.625 7.50001H12.75C13.7855 7.50001 14.625 8.33947 14.625 9.37501C14.625 10.4105 13.7855 11.25 12.75 11.25H11.25V14.625H12.75V12.75C14.614 12.75 16.125 11.239 16.125 9.37501C16.125 7.51105 14.614 6.00001 12.75 6.00001ZM3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Help.vue"]]);
